import {Injectable, Component} from '@angular/core';
import {Observable} from 'rxjs/Observable';

declare var $;

@Injectable()
export class SystemUtils {

	constructor() {
	}

    public getPageUrl(pageName:string) {
        let loc:string = window.location.pathname;
        let idx:number = loc.lastIndexOf('/');
        if (idx == loc.length - 1) {
            loc = loc.substring(0, idx - 1);
            idx = loc.lastIndexOf('/');
        }
        let dir:string = loc.substring(0, idx);

        return dir + "/" + pageName;
    }

    public stdTimezoneOffset(input:Date) {
        let jan:Date = new Date(input.getFullYear(), 0, 1);
        let jul:Date = new Date(input.getFullYear(), 6, 1);

        return Math.min(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    public minDstOffset(input:Date) {
        let jan:Date = new Date(input.getFullYear(), 0, 1);
        let jul:Date = new Date(input.getFullYear(), 6, 1);

        return Math.min(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    public maxDstOffset(input:Date) {
        let jan:Date = new Date(input.getFullYear(), 0, 1);
        let jul:Date = new Date(input.getFullYear(), 6, 1);

        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    public dst(input:Date) {
        let jan:Date = new Date(input.getFullYear(), 0, 1);
        let jul:Date = new Date(input.getFullYear(), 6, 1);

        if ( jan.getTimezoneOffset() == jul.getTimezoneOffset() ) {
            return false;
        }

        if ( this.minDstOffset(input) == input.getTimezoneOffset() ) {
            return false;
        } else if ( this.maxDstOffset(input) == input.getTimezoneOffset() ) {
            return true;
        } else {
            return false;
        }
    }

    public parseSystemDateTime(input:string, addUserOffset: boolean = true) {
        let datePart:string = input.substring(0, 10);
        let timePart:string = input.substring(11);

        let parts:Array<string> = datePart.split('-');
        let year:string = parts[0];
        let month:string = parts[1];
        let day:string = parts[2];

        parts = timePart.split(':');
        let hour:number = parseInt(parts[0]);
        let minute:string = parts[1];
        let second:string = parts[2].substring(0, 2);
        let meridian:string = parts[2].substring(3);
        if (meridian === "PM" && hour != 12) {
            hour = (hour - 0) + 12;
        } else if (meridian === "AM" && hour == 12) {
            hour = 0;
        }

        let localDateTime:Date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day),
                                          hour, parseInt(minute), parseInt(second));

        let estOffset:number = 4.0;
        if (this.dst(localDateTime)) {
            estOffset += 1.0;
        }
        let localOffset:number = localDateTime.getTimezoneOffset() / 60;
        let actualOffset:number = estOffset - localOffset;

        if (addUserOffset) {
            localDateTime.setTime(localDateTime.getTime() + (actualOffset * 60 * 60 * 1000));
        }

        return localDateTime;
    }

    public parseSystemDate(input:string) {
        let datePart:string = input.substring(0, 10);
        let timePart:string = input.substring(11);

        let parts:Array<string> = datePart.split('-');
        let year:string = parts[0];
        let month:string = parts[1];
        let day:string = parts[2];

        let localDateTime:Date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 0, 0, 0);

        let estOffset:number = 4.0;
        if (this.dst(localDateTime)) {
            estOffset += 1.0;
        }
        let localOffset:number = localDateTime.getTimezoneOffset() / 60;
        let actualOffset:number = estOffset - localOffset;

        localDateTime.setTime(localDateTime.getTime() + (actualOffset * 60 * 60 * 1000));
        localDateTime.setHours(0);
        localDateTime.setMinutes(0);
        localDateTime.setSeconds(0);

        return localDateTime;
    }

    public convertLocalToSystemDate(input:string, includeTime:boolean = false) {
        let datePart:string = input.substring(0, 10);
        let timePart:string = input.substring(11);

        let parts:Array<string> = datePart.split('-');
        let year:string = parts[0];
        let month:string = parts[1];
        let day:string = parts[2];

        let localDateTime:Date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 0, 0, 0);

        let estOffset:number = 4.0;
        if (this.dst(localDateTime)) {
            estOffset += 1.0;
        }
        let localOffset:number = localDateTime.getTimezoneOffset() / 60;
        let actualOffset:number = localOffset - estOffset;

        localDateTime.setTime(localDateTime.getTime() + (actualOffset * 60 * 60 * 1000));
        if ( !includeTime ) {
            localDateTime.setHours(0);
            localDateTime.setMinutes(0);
            localDateTime.setSeconds(0);
        }

        return localDateTime;
    }

    public addOffsetToUserDate(inputDate:Date, doAdd:boolean = true) {
        let estOffset:number = 4.0;
        if (this.dst(inputDate)) {
            estOffset += 1.0;
        }
        let localOffset:number = inputDate.getTimezoneOffset() / 60;
        let actualOffset:number = estOffset - localOffset;

        if (doAdd) {
            inputDate.setTime(inputDate.getTime() + (actualOffset * 60 * 60 * 1000));
        } else {
            inputDate.setTime(inputDate.getTime() - (actualOffset * 60 * 60 * 1000));
        }

        return inputDate;
    }

    public calculateAgeFromDateOfBirth(birthDate:Date) {
        let today:Date = new Date();
        let age:number = today.getFullYear() - birthDate.getFullYear();
        let m:number = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    public formatHeightFromInches(heightInches, useShort) {
        let feet:number, inches:number;

        feet = Math.floor(heightInches / 12);
        inches = heightInches % 12;

        if (useShort) {
            return feet + "." + inches;
        } else {
            return feet + "'" + inches + '"';
        }
    }

    public getOrdinalSuffix(number:number) {
        let suffixes:Array<string> = ["th", "st", "nd", "rd"];
        let relevantDigits:number = (number < 30) ? number % 20 : number % 30;

        return (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
    }

    public timeSince(date:Date) {
        let seconds: number = Math.floor((new Date().getTime() - date.getTime()) / 1000);

        let interval:number = Math.floor(seconds / 31536000);
        if (interval >= 1) {
            return interval + " year" + (interval === 1 ? "" : "s");
        }

        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            return interval + " month" + (interval === 1 ? "" : "s");
        }

        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
            return interval + " day" + (interval === 1 ? "" : "s");
        }

        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
            return interval + " hour" + (interval === 1 ? "" : "s");
        }

        interval = Math.floor(seconds / 60);
        if (interval >= 1) {
            return interval + " minute" + (interval === 1 ? "" : "s");
        }

        if (Math.floor(seconds) <= 5) {
            return "just now";
        }

        return Math.floor(seconds) + " seconds";
    }

    public displayGrowlMessage(msg: string, msgType: string, allowDismiss: boolean, icon = null) {
        let args = {
            message: msg
        };

        let opts = {
            type: msgType,
            allow_dismiss: allowDismiss,
            placement: {
                from: "top",
                align: "right"
            },
            animate: {
                enter: 'animated bounceInDown',
                exit: 'animated bounceOutUp'
            }
        };

        if (icon) {
            args['icon'] = icon;
            opts['icon_type'] = "class";
        }

        $.growl(args, opts);
    }

    public openWithoutReferrer(url: string, width: number = 400, height: number = 300) {
        let site: any = null;

        if (!width && !height) {
            site = window.open("", "hide_referrer");
        } else {
            let specs:string = "";
            let specDelim = "";

            if ( width ) {
                specs += specDelim + "width=" + width;
                specDelim = ",";
            }

            if (height) {
                specs += specDelim + "height=" + height;
                specDelim = ",";
            }

            site = window.open("", "hide_referrer", specs);
        }

        site.document.open();
        site.document.writeln('<script type="text/javascript">window.location = "' + url + '";</script>');
        site.document.close();

        return site;
    }

    public getTeamContextForTeam(teamCtx: Array<any>, team: any) {
        let retCtx: any = null;

        teamCtx.forEach(function(ctx) {
            if (ctx.team.id == team.id) {
                retCtx = ctx;
            }
        }.bind(this));

        return retCtx;
    }

    public generateNthDecorator(val: number) {
        let onesVal: number = val % 10;
        if (onesVal == 1 && val != 11) {
            return val + "st";
        } else if (onesVal == 2 && val != 12) {
            return val + "nd";
        } else if (onesVal == 3 && val != 13) {
            return val + "rd";
        } else {
            return val + "th";
        }
    }

}
